import { render, staticRenderFns } from "./categoryPop.vue?vue&type=template&id=1ab3cc36&scoped=true&"
import script from "./categoryPop.vue?vue&type=script&lang=js&"
export * from "./categoryPop.vue?vue&type=script&lang=js&"
import style0 from "./categoryPop.vue?vue&type=style&index=0&id=1ab3cc36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab3cc36",
  null
  
)

export default component.exports